export default __webpack_public_path__ + "static/media/banner.ebbf8d43.png";